import { render, staticRenderFns } from "./PrinterTonerManagementDetail.vue?vue&type=template&id=0d22a4fa&scoped=true"
import script from "./PrinterTonerManagementDetail.vue?vue&type=script&lang=js"
export * from "./PrinterTonerManagementDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d22a4fa",
  null
  
)

export default component.exports